import { createSlice } from "@reduxjs/toolkit";
import { GradePremiacaoModel } from "../../../models/gradePremiacao/gradePremiacaoModel";
import { buscarGradePremiacao, buscarGradePremiacaoPorId } from "../../../services/gradePremiacaoService";
import { resetAll } from "../../actions/actions";

export interface GradePremiacaoState {
  //buscar grade premiacao
  loading: boolean;
  busca: string | null;
  list: GradePremiacaoModel[];
  //internal
  entity: GradePremiacaoModel;
  modalCadastrar: boolean;
  modalDeletar: boolean;
  formGrade: GradePremiacaoModel;
}

const initialState: GradePremiacaoState = {
  //buscar grade premiacao
  loading: false,
  busca: null,
  list: [],
  //internal
  entity: {} as GradePremiacaoModel,
  modalCadastrar: false,
  modalDeletar: false,
  formGrade: {} as GradePremiacaoModel,
};

export const gradePremiacaoSlice = createSlice({
  name: "gradePremiacao",
  initialState,
  reducers: {
    //buscar grade premiacao
    setBuscaGradePremiacao: (state, action) => {
      state.busca = action.payload;
    },
    //internal
    setEntityGradePremiacao: (state, action) => {
      state.entity = action.payload;
    },
    setModalCadastrarGradePremiacao: (state, action) => {
      state.modalCadastrar = action.payload;
    },
    setModalDeletarGradePremiacao: (state, action) => {
      state.modalDeletar = action.payload;
    },
    setFormGrade: (state, action) => {
      state.formGrade = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar
    builder.addCase(buscarGradePremiacao.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarGradePremiacao.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarGradePremiacao.rejected, (state, action) => {
      state.loading = false;
    });

    //buscar por id
    builder.addCase(buscarGradePremiacaoPorId.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarGradePremiacaoPorId.fulfilled, (state, action) => {
      state.entity = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarGradePremiacaoPorId.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar grade premiacao
  setBuscaGradePremiacao,
  //internal
  setEntityGradePremiacao,
  setModalCadastrarGradePremiacao,
  setModalDeletarGradePremiacao,
  setFormGrade,
} = gradePremiacaoSlice.actions;

export default gradePremiacaoSlice.reducer;
